<template>
	<div class="page">
		<top />
		<div style="width: 100%; height: 55px"></div>
		<el-dialog :visible.sync="qqShow" width="80%" center>
			<div class="qq-text">
				<span>客服QQ</span>
				<span style="padding-left: 29px">{{ webQq }}</span>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="qqShow = false" class="qqbtn">确 定</el-button>
			</span>
		</el-dialog>
		<!--  v-if="is_search_img != 1" -->
		<div class="mid2" v-if="is_search_img != 1">
			<el-select class="select" multiple v-model="format_checkeds" @change="changeformat" placeholder="选择格式">
				<el-option :label="itm" :value="itm" v-for="(itm, idx) in format_arr" :key="idx"></el-option>
			</el-select>
		</div>
		<div class="mid2" v-if="is_search_img == 1">
			<el-select class="select" multiple v-model="format_checkeds" @change="changeformat" placeholder="选择格式">
				<el-option :label="itm" :value="itm" v-for="(itm, idx) in format_arr" :key="idx"></el-option>
			</el-select>
			<el-select class="select" v-model="choose_index" placeholder="请选择类型" @change="changetype">
				<el-option :label="item.typename" :value="index" v-for="(item, index) in arctype"
					:key="index"></el-option>
			</el-select>
			<el-select v-if="choose_index !== ''" class="select" v-model="choose_type"
				:placeholder="arctype[choose_index].typename" @change="change">
				<el-option label="全部" value=""></el-option>
				<el-option :label="itemm.typename" :value="itemm.id"
					v-for="(itemm, indexx) in arctype[choose_index].son" :key="indexx"></el-option>
			</el-select>
		</div>
		<div class="bottom">
			<div class="bt-left" v-if="is_search_img == 1">
				<div class="div">以图搜图结果</div>
				<div>搜索结果数：{{ list.length }}</div>
				<div>
					<span @click="qqShow = true" href="#" target="_blank"
						style="color: rgb(49, 122, 218); font-weight: bold">没有找到一样的图案？联系客服马上定制！</span>
				</div>
			</div>
			<div class="bottomimg">
				<div class="bottomimg2" v-for="(item, index) in list" :key="index"
					@click="go('Details', item.aid,item.sign)">
					<img v-if="item.sales_num >= hot_limit" class="poa" src="../../assets/bao.png"
						:alt="'以图绘图印花设计网-' + item.title" />
					<img :src="imageUrl(item.litpic_watermark)" :alt="'以图绘图印花设计网-' + item.title" />
				</div>
			</div>
			<div class="page" v-if="is_search_img != 1">
				<el-pagination @current-change="handleCurrentChange" :current-page="page" :page-size="size"
					layout="total, prev, pager, next, jumper" :pager-count="5" :total="count">
				</el-pagination>
			</div>
		</div>
		<info />
		<div style="width: 100%; height: 60px; background-color: #f6f6f6"></div>
		<foot />
	</div>
</template>
<script>
	import top from "../../components/common/header.vue";
	import foot from "../../components/common/footer.vue";
	import info from "../../components/common/qrCode.vue";
	import {
		checkOriginalAuth
	} from "../../request/api";
	import {
		search,
		footData
	} from "../../request/api";
	export default {
		components: {
			top,
			foot,
			info,
		},
		data() {
			return {
				list: "",
				type: "",
				count: 1,
				size: 20,
				page: 1,
				arctype: "", //分类
				choose_type: [],
				is_search_img: null,
				bounced: false,
				qqShow: false,
				webQq: "",
				format_checkeds: [],
				format_arr: [],
				choose_index: ''
			};
		},
		created() {
			document.title = '以图绘图印花设计网';
			if (this.$store.getters.getPage2.length !== 0) {
				this.page = this.$store.getters.getPage2;
			}
			this.getData();
			this.getFootData();
			console.log(this.$route.query.type);
		},
		methods: {
			//获取数据
			getData() {
				let choose_type = ''
				if (this.choose_index !== '' && this.choose_type == '') {
					choose_type = this.arctype[this.choose_index].id
				}
				if (this.choose_index !== '' && this.choose_type !== '') {
					choose_type = this.arctype[this.choose_index].id + ',' + this.choose_type.toString()
				}
				search({
					imgs: this.$route.query.imgs,
					type: this.$route.query.type,
					keysWord: this.$route.query.keysWord,
					formats: this.format_checkeds.toString(),
					choose_type: choose_type,
					page: this.page,
				}).then((res) => {
					console.log(res);
					this.count = res.data.count;
					this.list = res.data.list;
					this.arctype = res.data.arctype;
					this.is_search_img = Number(res.data.is_search_img);
					this.bounced = true;
					this.hot_limit = res.data.hot_limit;
					this.format_arr = res.data.format_arr;
				});
			},
			go(url, aid, sign) {
				checkOriginalAuth({
					aid: aid,
					sign: sign
				}).then((res) => {
					if (res.code == 500) {
						this.$message({
							message: res.msg,
							type: "warning",
						});
						return;
					}
					if (res.code == 200) {
						this.$store.commit("setPage1", this.page);
						this.$router.push({
							name: url,
							query: {
								aid: aid,
							},
						});
					}
				});
			},
			//分页
			handleCurrentChange(val) {
				this.page = val;
				window.scrollTo(0, 0);
				this.getData();
			},
			contact() {
				this.bounced = false;
				this.qqShow = true;
			},
			//获取数据
			getFootData() {
				footData({}).then((res) => {
					this.webQq = res.data.webQq.value;
				});
			},
			changeformat() {
				this.page = 1;
				this.getData();
			},
			change(val) {
				this.page = 1;
				this.getData();
			},
			changetype(){
				this.choose_type = ''
				this.page = 1;
				this.getData();
			},
		},
		watch: {
			$route: {
				// 亲测有效,我是用来监听query参数变化
				handler() {
					this.aid = this.$route.query.aid;
					this.getData();
					//深度监听，同时也可监听到param参数变化
				},
				deep: true,
			},
		},
	};
</script>
<style lang="less">
	.page {
		background: #f6f6f6;

		.mid2 {
			padding: 0 9px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			flex-wrap: wrap;
			margin-top: 10px;
		}

		.mid {
			margin-top: 13px;
			padding: 0 9px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			flex-wrap: wrap;
		}

		.bottom {
			padding: 10px;

			.bottomimg {
				display: flex;
				align-items: center;
				justify-content: space-between;
				flex-wrap: wrap;

				img {
					width: 170px;
					height: 170px;
					margin-bottom: 10px;
				}
			}

			.bottomimg2 {
				position: relative;
			}

			.page {
				position: relative;
				left: 0%;

				.el-pager {
					margin-bottom: 10px;
				}

				.el-pager li {
					min-width: 28px;
				}

				.el-pagination {
					padding: 0;
					display: flex;
					flex-wrap: wrap;
					justify-content: center;
				}

				.btn-prev {
					padding-right: 6px;
				}

				.btn-next {
					padding-left: 6px;
				}
			}
		}
	}

	.select {
		width: 48%;
		margin: 2px 0;
	}

	.select .el-input--suffix .el-input__inner {
		padding: 0 8px !important;
	}

	.content {
		text-align: center;
		font-size: 16px;
	}

	.df {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 30px;
	}

	.bottom-top {
		padding: 30px 20px;
		text-align: left;
	}

	.wrap {
		width: 100%;
	}

	.sb {
		justify-content: space-between;
		-webkit-justify-content: space-between;
	}

	.flex {
		display: flex;
		display: -webkit-flex;
		align-items: center;
		-webkit-align-items: center;
	}

	.bt-left .div {
		height: 32px;
		line-height: 32px;
		border-radius: 2px;
		background-color: #000;
		padding: 0 15px;
		color: #fff;
		font-size: 14px;
		width: fit-content;
		margin-right: 10px;
	}

	.bt-left div {
		margin-bottom: 5px;
	}

	.bt-left {
		font-size: 14px;
		color: #666;
	}

	.poa {
		position: absolute;
		width: 26px !important;
		height: 30px !important;
		left: 6px;
		top: 8px;

		img {
			position: absolute;
			width: 100% !important;
			height: 100% !important;
		}
	}
</style>